import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { createLLMUsageTier } from "../graphql/mutations";
import {
  CreateLLMUsageTierInput,
  CreateLLMUsageTierMutation,
  LLMUsageTierStatus,
} from "../API";

// Accept a flexible payload from the form and compute required fields like version
type CreateUsageTierPayload = Omit<Partial<CreateLLMUsageTierInput>, "version"> & {
  projectId: string;
  status: LLMUsageTierStatus;
  name: string;
  version?: number | null;
};

export async function createLLMUsageTierAfterEdit(
  values: CreateUsageTierPayload
): Promise<GraphQLResult<CreateLLMUsageTierMutation>> {
  const nowIso = new Date().toISOString();
  const shouldSetActiveAt = values.status === LLMUsageTierStatus.ACTIVE;
  return API.graphql(
    graphqlOperation(createLLMUsageTier, {
      input: {
        projectId: values.projectId,
        status: values.status,
        name: values.name,
        description: values.description || "",
        // Versioning & lineage
        version: values.version ?? 1,
        activeAt: values.activeAt ?? (shouldSetActiveAt ? nowIso : undefined),
        inactiveAt: values.inactiveAt ?? undefined,
        priorUsageTierId: values.priorUsageTierId ?? null,
        baseUsageTierId: values.baseUsageTierId ?? null,
        replenishmentPeriod: values.replenishmentPeriod,
        replenishmentMethod: values.replenishmentMethod,
        usageLimitAction: values.usageLimitAction,
        standardTokenReplenishmentAmount: values.standardTokenReplenishmentAmount || 0,
        premiumTokenReplenishmentAmount: values.premiumTokenReplenishmentAmount || 0,
        superPremiumTokenReplenishmentAmount: values.superPremiumTokenReplenishmentAmount || 0,
        reasoningTokenReplenishmentAmount: values.reasoningTokenReplenishmentAmount || 0,
        standardCallReplenishmentAmount: values.standardCallReplenishmentAmount || 0,
        premiumCallReplenishmentAmount: values.premiumCallReplenishmentAmount || 0,
        superPremiumCallReplenishmentAmount: values.superPremiumCallReplenishmentAmount || 0,
        reasoningCallReplenishmentAmount: values.reasoningCallReplenishmentAmount || 0,
        standardTokenUnlimited: values.standardTokenUnlimited ?? false,
        premiumTokenUnlimited: values.premiumTokenUnlimited ?? false,
        superPremiumTokenUnlimited: values.superPremiumTokenUnlimited ?? false,
        reasoningTokenUnlimited: values.reasoningTokenUnlimited ?? false,
        standardCallUnlimited: values.standardCallUnlimited ?? false,
        premiumCallUnlimited: values.premiumCallUnlimited ?? false,
        superPremiumCallUnlimited: values.superPremiumCallUnlimited ?? false,
        reasoningCallUnlimited: values.reasoningCallUnlimited ?? false,
      },
    })
  ) as Promise<GraphQLResult<CreateLLMUsageTierMutation>>;
}
